import SvgIcon, { SvgIconProps } from '../components/SvgIcon';

interface Props extends SvgIconProps {}

const AttendanceWhiteIcon = ({ ...props }: Props) => {
  return (
    <SvgIcon width={72} height={72} viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <line
        x1="13.9376"
        y1="20.3315"
        x2="35.3315"
        y2="10.0624"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeDasharray="4 5"
      />
      <line
        x1="18.3544"
        y1="59.5169"
        x2="48.5169"
        y2="50.6456"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeDasharray="4 5"
      />
      <line
        x1="60.3494"
        y1="27.4858"
        x2="53.4858"
        y2="50.6506"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeDasharray="4 5"
      />
      <line
        x1="56.2146"
        y1="25.4915"
        x2="39.4915"
        y2="13.7854"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeDasharray="4 5"
      />
      <line
        x1="14.8064"
        y1="60.2145"
        x2="11.2145"
        y2="25.1936"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeDasharray="4 5"
      />
      <line
        x1="31.0069"
        y1="35.3569"
        x2="56.3569"
        y2="23.9931"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeDasharray="4 5"
      />
      <line
        x1="32.7839"
        y1="37.5003"
        x2="52.5003"
        y2="51.2161"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeDasharray="4 5"
      />
      <line
        x1="15.8229"
        y1="22.8236"
        x2="29.8236"
        y2="35.1771"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeDasharray="4 5"
      />
      <circle cx="38" cy="11" r="6" fill="white" />
      <circle cx="13" cy="23" r="6" fill="white" />
      <circle cx="51" cy="52" r="6" fill="white" />
      <circle cx="30" cy="38" r="6" fill="white" />
      <circle cx="59" cy="25" r="6" fill="white" />
      <circle cx="17" cy="62" r="6" fill="white" />
    </SvgIcon>
  );
};

export default AttendanceWhiteIcon;
